"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchObject = exports.patchContainsChanges = exports.isPatchable = void 0;
const PatchableArray_1 = require("../structs/PatchableArray");
const AutoEncoder_1 = require("./AutoEncoder");
function isPatchable(object) {
    if (!object) {
        return false;
    }
    return !!object.patch;
}
exports.isPatchable = isPatchable;
function patchContainsChanges(patch, model, context) {
    const patched = model.patch(patch);
    return JSON.stringify(patched.encode(context)) != JSON.stringify(model.encode(context));
}
exports.patchContainsChanges = patchContainsChanges;
/**
 * Use this method to encode an object (might be an encodeable implementation) into a decodable structure
 */
function patchObject(obj, patch) {
    if (patch === undefined) {
        // When a property is set to undefined, we always ignore it, always. You can never set something to undefined.
        // Use null instead.
        return obj;
    }
    if (isPatchable(obj)) {
        if (patch == null) {
            return null;
        }
        else {
            if (patch instanceof AutoEncoder_1.AutoEncoder && patch.isPut()) {
                // Instance type could be different
                return patch;
            }
            else {
                return obj.patch(patch);
            }
        }
    }
    else {
        if (Array.isArray(obj)) {
            // Check if patch is a patchable array
            if (patch instanceof PatchableArray_1.PatchableArray) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return patch.applyTo(obj);
            }
            else {
                // What happens when an array field is set?
                // This can only happen when the autocoder is not identifieable, but
                // technically also in other cases if typescript doesn't check types
                // we just take over the new values and 'remove' all old elements
                return patch;
            }
        }
        else {
            if ((obj === undefined || obj === null) && patch instanceof PatchableArray_1.PatchableArray) {
                // Patch on optional array: ignore if empty patch, else fake empty array patch
                if (patch.changes.length === 0) {
                    return obj;
                }
                const patched = patch.applyTo([]);
                if (patched.length === 0) {
                    // Nothing changed, keep it undefined or null
                    return obj;
                }
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return patched;
            }
            else {
                return patch;
            }
        }
    }
}
exports.patchObject = patchObject;
//# sourceMappingURL=Patchable.js.map